module.exports = "<div class=\"small btn grid btn-darkteal\" ng-show=\"$root.loading\" class=\"ng-hide\">\n    <span>Loading</span>\n    <div class=\"spinner\" style=\"display: inline-block;\">\n        <div class=\"double-bounce1\"></div>\n        <div class=\"double-bounce2\"></div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./project/components/fb-loading/fb-loading.html
// module id = 818
// module chunks = 3